import { render, staticRenderFns } from "./Collapser.vue?vue&type=template&id=5a399210&scoped=true"
import script from "./Collapser.vue?vue&type=script&lang=js"
export * from "./Collapser.vue?vue&type=script&lang=js"
import style0 from "./Collapser.vue?vue&type=style&index=0&id=5a399210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a399210",
  null
  
)

export default component.exports